import styles from "./Separator.module.scss"

export const Separator = () => (
  <div>
    <div className={styles.separator} />
  </div>
)
